import { FC } from 'react'

import {
  GenreWithoutCurators,
  MergedGenres,
} from '../AdsGenresModalContent/helpers'

import { AdSearchGenresList } from './AdSearchGenresList'
import { AdPredefinedGenresList } from './AdPredefinedGenresList'

type AdsGenresModalReadyToSelectListsProps = {
  debouncedSearchValue: string
  onSetSelectedGenres: (genre: GenreWithoutCurators) => void
  selectedGenres: GenreWithoutCurators[]
  data?: MergedGenres
}
export const AdsGenresModalReadyToSelectLists: FC<
  AdsGenresModalReadyToSelectListsProps
> = (props) => {
  const { debouncedSearchValue, selectedGenres, data, onSetSelectedGenres } =
    props

  return (
    <>
      {Boolean(debouncedSearchValue) && (
        <AdSearchGenresList
          searchValue={debouncedSearchValue}
          selectedGenres={selectedGenres}
          genres={data?.predefinedGenres.map((item) => item.genres).flat()}
          onClickGenre={onSetSelectedGenres}
        />
      )}

      {!debouncedSearchValue && (
        <AdPredefinedGenresList
          selectedGenres={selectedGenres}
          genres={data?.predefinedGenres}
          onClickGenre={onSetSelectedGenres}
        />
      )}
    </>
  )
}
